<template>
  <div>
    <btn @click.native=""><i class="fa fa-user-plus"></i></btn>
    <component-modal v-show="condition.condition" transition="expand">
      <template slot="title">生徒登録</template>
      <div slot="body">
        <search :searchtext='searchText' v-show="condition.condition2">
          <select v-model="searchType">
            <option value="id">ID</option>
            <option value="f_name + l_name">名前</option>
            <option value="f_name_kana + l_name_kana">読み</option>
            <option value="family.pref + family.address1 + family.address2">住所</option>
            <option value="family.tel1">電話番号</option>
            <option value="created_at">登録日</option>
          </select>
        </search>
        <humanlist v-show="condition.condition2">
          <table-c>
            <tr-c slot="tr-th">
              <th-c @click.native='sort("id")'>ID</th-c>
              <th-c>名前</th-c>
              <th-c>読み</th-c>
              <th-c>住所</th-c>
              <th-c>電話番号</th-c>
              <th-c @click.native='sort("created_at")'>登録日</th-c>
            </tr-c>
            <tr-c slot="tr-td" @click.native="[getData(list), showTable(list)]" v-for="(list, index) in students" class="tr_hover" :key="index.id">
              <td-c>{{list.id}}</td-c>
              <td-c>{{list.f_name}} {{list.l_name}}</td-c>
              <td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
              <td-c>{{list.family.pref}}{{list.family.address1}}{{list.family.address2}}</td-c>
              <td-c>{{list.family.tel1}}</td-c>
              <td-c>{{list.created_at.substring(0, 10)}}</td-c>
            </tr-c>
          </table-c>
        </humanlist>
        <table class="m-table" v-show="condition.condition3">
          <tbody>
            <!-- <tr> -->
            <!--   <th>生徒ID</th> -->
            <!--   <td><p>{{human.student_id}}</p></td> -->
            <!-- </tr> -->
            <tr>
              <th>生徒名</th>
              <td style="padding: .5em">{{student_tutor.f_name}} {{student_tutor.l_name}}</td>
            </tr>
            <tr>
              <th>指導開始日</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="student_tutor.guidance_period_start" placeholder="指導開始日"></td>
            </tr>
            <tr>
              <th>指導終了日</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="student_tutor.guidance_period_end" placeholder="指導終了日"></td>
            </tr>
            <tr>
              <th>備考</th>
              <td><input type='text' v-model="student_tutor.note"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="footer" slot="footer">
        <btn @click.native="" v-show="condition.condition3">登録</btn>
        <btn @click.native="exitModal" v-show="condition.condition3">キャンセル</btn>
      </div>
    </component-modal>
  </div>
</template>

<script>
export default {
  name: 'TutorStudentsModal',
  props: {
    tutor: Object
  },
  data () {
    return {
      condition: {
        condition: false,
        condition2: true,
        condition3: false
      },
      searchText: '',
      searchType: 'id',
      order: -1,
      show: false,
      show2: false,
      type: 'date', // date datetime
      value: '',
      begin: '2015-12-20',
      end: '2016-12-25',
      x: 0,
      y: 0,
      x2: 0,
      y2: 0,
      range: false, // 期間選択
      student_tutor: {
        student_id: '',
        // f_name: '',
        // l_name: '',
        guidance_period_start: '',
        guidance_period_end: '',
        note: ''
      }
    }
  },
  computed: {
    tutor_id () {
      return this.$store.state.item.tutor.id
    },

    students () {
      return this.$store.getters.students
    }
  },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
      // console.log(selectedOption.name)
      // console.log(selectedOption.value)
    },

    showModal () {
      this.condition.condition = !this.condition.condition
    },

    showTable (list) {
      this.condition.condition2 = !this.condition.condition2
      this.condition.condition3 = !this.condition.condition3
    },

    exitModal () {
      this.condition.condition = !this.condition.condition
      this.condition.condition2 = !this.condition.condition2
      this.condition.condition3 = !this.condition.condition3
      this.student_tutor.guidance_period_start = ''
      this.student_tutor.guidance_period_end = ''
      this.student_tutor.note = ''
    },

    sort (header) {
      this.order = this.order * -1
    },

    getData (list) {
      this.student_tutor.student_id = list.id
      this.student_tutor.f_name = list.f_name
      this.student_tutor.l_name = list.l_name
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
table {
  border-spacing: 0;
  width: 100%;
  tr {
    th {
      border-bottom: solid 1px #ddd;
      background: #337bc4;
      color: #fff;
      padding: 10px;
    }
    td {
      border-bottom: solid 1px #ddd;
      input {
        outline: 0;
        border: none;
        width: 100%;
      }
      .half {
        width: 50%;
      }
      textarea {
        outline: 0;
        border: none;
        width: 100%;
      }
    }
  }
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
.fa-user-plus {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// TutorStudentsModal.vue?00e76886